module.exports = __webpack_public_path__ + "img/Logo_RemitPro_White.a87e3789.png";